
























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import {ListSection} from '@/store/models';

@Component({components: {}})
export default class Comment extends Vue {
  @Prop() readonly section!: any;

  visible: boolean = true;
  customComment: string = '';
  selected: string = 'auto';

  options = [
    {text: 'Automatisk kommentar', value: 'auto'},
    {text: 'Egen kommentar', value: 'custom'},
  ];

  selectedChanged(value: string) {
    this.update();
  }

  @Watch('section', {immediate: true, deep: true})
  onData() {
    this.visible = !this.section.Hidden;
    if (this.section.Comment) {
      this.customComment = this.section.Comment;
      this.selected = 'custom';
    }
  }

  @Watch('visible', {immediate: false, deep: false})
  visibleChanged() {
    if (this.section.Hidden === !this.visible) {
      return;
    }
    this.update();
  }

  async update() {
    const s = {
      Id: this.section.Id,
      Kind: this.section.Kind,
      Type: this.section.Type,
      SubType: this.section.SubType,
      Comment: this.selected === 'auto' ? '' : this.customComment,
      Hidden: !this.visible,
    };
    dokument.updateItem(s);
  }

  get comment() {
    if (this.selected === 'auto') {
      if (dokument.ranking) {
        return dokument.ranking.sheets[0].comment;
      } else {
        return '';
      }
    } else {
      if (!this.customComment && dokument.ranking) {
        this.customComment = dokument.ranking.sheets[0].comment;
      }
      return this.customComment;
    }
  }

  set comment(value: string) {
    this.customComment = value;
    this.update();
  }

}
